import { useTheme } from '@material-ui/core';

export function useDefaultThresholdColors() {
  const theme = useTheme();

  const defaultThresholdColors = [
    {
      label: 'Red' as const,
      value: theme.palette.error.main,
      defaultLabel: 'error',
    },
    {
      label: 'Yellow' as const,
      value: theme.palette.warning.main,
      defaultLabel: 'warning',
    },
    {
      label: 'Green' as const,
      value: theme.palette.success.main,
      defaultLabel: 'passed',
    },
  ];

  return { defaultThresholdColors };
}
